//#region IMPORT
import React, { useEffect, useState } from 'react';
import M_TBG_CUSTOM_05 from './M_TBG_CUSTOM_05';
import Global from '../../../../Services/Common/Global';
import * as pdfjsLib from 'pdfjs-dist';
import 'pdfjs-dist/build/pdf.worker.entry';
import { useDispatch, useSelector } from 'react-redux';
import { CommonActions } from '../../../../Reducer/CommonReducer';
import dayjs from 'dayjs';
import { useSearch1 } from './M_TBG_CUSTOM_05_Query';
import Commons from '../../../../Services/Common/Common';
//#endregion

function M_TBG_CUSTOM_05F(props) {
  //#region 변수
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const dispatch = useDispatch();
  const activeStep = useSelector((state) => state.common.activeStep);
  const [loading, setLoading] = useState(false);
  const [pdfImages, setPdfImages] = useState([]);
  //#endregion

  //#region 이벤트
  //#endregion

  //#region 쿼리
  const { runAsync: Search1 } = useSearch1({
    onSuccess: async (rows) => {
      const reportData = rows?.[0];
      if (!reportData || reportData?.type === 'Error') {
        console.error('레포트 데이터 조회 실패');
        return;
      }

      setLoading(true);
      let depSignBase64 = null;
      let depSignBase642 = null;
      let depSignBase643 = null;
      let depSignBase644 = null;

      if (reportData.depSignPath1) {
        try {
          const imageUrl1 =
            Global.file.useUrl + 'files/' + reportData.depSignPath1;
          const base64Image1 = await ConvertImageToBase64(imageUrl1);
          depSignBase64 = base64Image1.replace(
            /^data:image\/[a-z]+;base64,/,
            ''
          );
        } catch (error) {
          depSignBase64 = null;
        }
      }

      if (reportData.depSignPath2) {
        try {
          const imageUrl2 =
            Global.file.useUrl + 'files/' + reportData.depSignPath2;
          const base64Image2 = await ConvertImageToBase64(imageUrl2);
          depSignBase642 = base64Image2.replace(
            /^data:image\/[a-z]+;base64,/,
            ''
          );
        } catch (error) {
          depSignBase642 = null;
        }
      }

      if (reportData.depSignPath3) {
        try {
          const imageUrl3 =
            Global.file.useUrl + 'files/' + reportData.depSignPath3;
          const base64Image3 = await ConvertImageToBase64(imageUrl3);
          depSignBase643 = base64Image3.replace(
            /^data:image\/[a-z]+;base64,/,
            ''
          );
        } catch (error) {
          depSignBase643 = null;
        }
      }

      if (reportData.depSignPath4) {
        try {
          const imageUrl4 =
            Global.file.useUrl + 'files/' + reportData.depSignPath4;
          const base64Image4 = await ConvertImageToBase64(imageUrl4);
          depSignBase644 = base64Image4.replace(
            /^data:image\/[a-z]+;base64,/,
            ''
          );
        } catch (error) {
          depSignBase644 = null;
        }
      }

      let smSignBase64 = null;
      if (reportData.safetySignaturePath) {
        try {
          const imageUrlSm =
            Global.file.useUrl + 'files/' + reportData.safetySignaturePath;
          const base64ImageSm = await ConvertImageToBase64(imageUrlSm);
          smSignBase64 = base64ImageSm.replace(
            /^data:image\/[a-z]+;base64,/,
            ''
          );
        } catch (error) {
          smSignBase64 = null;
        }
      }

      const selectedRiskCodes = reportData.selectedRiskCodes
        ? reportData.selectedRiskCodes.split(',').map((code) => code.trim())
        : [];

      const riskItems = [];
      if (reportData.riskItemsList) {
        const riskItemsArray = reportData.riskItemsList.split('||');
        riskItemsArray.forEach((item) => {
          const [code, name] = item.split('|');
          const isChecked = selectedRiskCodes.includes(code);
          riskItems.push({
            code: code,
            name: name,
            checked: isChecked,
          });
        });
      }

      const selectedEquipmentCodes = reportData.selectedEquipmentCodes
        ? reportData.selectedEquipmentCodes.split(',').map((code) =>
          code.trim()
        )
        : [];

      const equipmentItems = [];
      if (reportData.equipmentItemsList) {
        const equipmentItemsArray = reportData.equipmentItemsList.split('||');
        equipmentItemsArray.forEach((item) => {
          const [code, name] = item.split('|');
          const isChecked = selectedEquipmentCodes.includes(code);
          equipmentItems.push({
            code: code,
            name: name,
            checked: isChecked,
          });
        });
      }

      const selectedPreparationCodes = reportData.selectedPreparationCodes
        ? reportData.selectedPreparationCodes.split(',').map((code) =>
          code.trim()
        )
        : [];

      const preparationItems = [];
      if (reportData.preparationItemsList) {
        const preparationItemsArray =
          reportData.preparationItemsList.split('||');
        preparationItemsArray.forEach((item) => {
          const [code, name] = item.split('|');
          const isChecked = selectedPreparationCodes.includes(code);
          preparationItems.push({
            code: code,
            name: name,
            checked: isChecked,
          });
        });
      }

      const workTypeCode =
        reportData.workTypeCode || reportData.workType || '';
      const tableDataMain = [
        {
          WT_001: workTypeCode === 'WT_001',
          WT_002: workTypeCode === 'WT_002',
          WT_003: workTypeCode === 'WT_003',
          WT_004: workTypeCode === 'WT_004',
          WT_005: workTypeCode === 'WT_005',
          WT_006: workTypeCode === 'WT_006',
        },
      ];

      const riskRowData = {};
      riskItems.forEach((item, index) => {
        const fieldIndex = index + 1;
        riskRowData[`RISK_${fieldIndex}_CHECKED`] = item.checked;
        riskRowData[`RISK_${fieldIndex}_NAME`] = item.name;
        riskRowData[`RISK_${fieldIndex}_CODE`] = item.code;
      });

      const riskTableDataHorizontal = [riskRowData];

      const equipmentRowData = {};
      equipmentItems.forEach((item, index) => {
        const fieldIndex = index + 1;
        equipmentRowData[`EQUIP_${fieldIndex}_CHECKED`] = item.checked;
        equipmentRowData[`EQUIP_${fieldIndex}_NAME`] = item.name;
        equipmentRowData[`EQUIP_${fieldIndex}_CODE`] = item.code;
      });

      const equipmentTableDataHorizontal = [equipmentRowData];

      const validPreparationItems = preparationItems.filter(
        (item) => item && item.code && item.name
      );

      let validWorkerNames = [];
      if (reportData.workList) {
        validWorkerNames = reportData.workList.split(',')
          .map((name) => name.trim())
          .filter((name) => name);
      }

      const maxRowCount = Math.max(
        validPreparationItems.length,
        validWorkerNames.length
      );

      const preparationTableData = [];
      for (let i = 0; i < maxRowCount; i++) {
        const prepItem =
          i < validPreparationItems.length ? validPreparationItems[i] : null;
        const workerName =
          i < validWorkerNames.length ? validWorkerNames[i] : '';

        preparationTableData.push({
          PREP_CODE: prepItem?.code || '',
          PREP_NAME: prepItem?.name || '',
          PREP_CHECKED: prepItem?.checked || false,
          WORKER_NAME: workerName,
        });
      }

      const permitDate = reportData.createDate
        ? dayjs(reportData.createDate).format('YYYY-MM-DD')
        : '';

      const depApproverIds = reportData.depApproverId
        ? reportData.depApproverId.split(', ')
        : [];
      const depApproverIdArray = [];
      for (let i = 0; i < 4; i++) {
        depApproverIdArray.push(depApproverIds[i] || '');
      }

      const headerData = {
        PERMIT_DATE: permitDate,
        PERMIT_NUMBER: reportData.pmCd || '',
        PERMISSION_DATE: permitDate,
        PERMISSION_NO: reportData.pmCd || '',
        SITE_NAME: reportData.siteName || '',
        MANAGER_ID: reportData.managerId || '',
        MANAGER_NAME: reportData.managerName || '',
        MANAGER_DEP_CD: reportData.managerDepCd || '',
        MANAGER_DEP_NM: reportData.managerDepNm || '',
        MANAGER_POSITION: reportData.managerPosition || '',
        MANAGER_PHONE: reportData.managerPhone || '',
        ETC_CONTENT: reportData.etcContent || '',
        COMPANY_NAME: reportData.companyName || '',
        DEP_NM: reportData.depNm || '',
        USER_POSITION: reportData.userPosition || '',
        USER_NAME: reportData.userName || '',
        USER_DEP_NM: reportData.userDepNm || '',
        WORK_START_DATE: reportData.workStartDate
          ? dayjs(reportData.workStartDate).format('YYYY-MM-DD HH:mm')
          : '',
        WORK_END_DATE: reportData.workEndDate
          ? dayjs(reportData.workEndDate).format('YYYY-MM-DD HH:mm')
          : '',
        PLANNED_PERSONNEL:
          reportData.plannedPersonnel || reportData.planNum || '',
        PLAN_NUM: reportData.planNum || reportData.plannedPersonnel || '',
        NUMBER_OF_WORKERS: reportData.numberOfWorkers || '',
        WORK_LOCATION: reportData.workLocation || '',
        WORK_DESCRIPTION: reportData.workDescription || '',
        WORK_LIST: reportData.workList || reportData.workDescription || '',
        WORK_TYPE_NAME: reportData.workTypeName || '',
        SELECTED_RISK_NAMES: reportData.selectedRiskNames || '',
        PREVENTIVE_MEASURES: reportData.preventiveMeasures || '',
        GUARDIAN: reportData.guardian || '',
        SELECTED_EQUIPMENT_NAMES: reportData.selectedEquipmentNames || '',
        SELECTED_PREPARATION_NAMES: reportData.selectedPreparationNames || '',
        OTHER_SPECIAL_NOTES: reportData.otherSpecialNotes || '',
        DEP_APPROVAL_STATUS_1: reportData.depApprovalStatus1 || '',
        DEP_APPROVER_ID_1: depApproverIdArray[0] || '',
        DEP_APPROVER_NM_1: reportData.depApproverNm1 || '',
        DEP_APPROVER_POSITION_1: reportData.depApproverPosition1 || '',
        DEP_APPROVER_DEP_NM_1: reportData.depApproverDepNm1 || '',
        DEP_SIGN_PATH_1: depSignBase64 || null,
        DEP_APPROVER_UPDATE_DATE_1: reportData.depApproverUpdateDate1
          ? dayjs(reportData.depApproverUpdateDate1).format('YYYY/MM/DD')
          : '',
        DEP_APPROVER_ID_2: depApproverIdArray[1] || '',
        DEP_APPROVER_NM_2: reportData.depApproverNm2 || '',
        DEP_APPROVER_POSITION_2: reportData.depApproverPosition2 || '',
        DEP_APPROVER_DEP_NM_2: reportData.depApproverDepNm2 || '',
        DEP_SIGN_PATH_2: depSignBase642 || null,
        DEP_APPROVER_UPDATE_DATE_2: reportData.depApproverUpdateDate2
          ? dayjs(reportData.depApproverUpdateDate2).format('YYYY/MM/DD')
          : '',
        DEP_APPROVER_ID_3: depApproverIdArray[2] || '',
        DEP_APPROVER_NM_3: reportData.depApproverNm3 || '',
        DEP_APPROVER_POSITION_3: reportData.depApproverPosition3 || '',
        DEP_APPROVER_DEP_NM_3: reportData.depApproverDepNm3 || '',
        DEP_SIGN_PATH_3: depSignBase643 || null,
        DEP_APPROVER_UPDATE_DATE_3: reportData.depApproverUpdateDate3
          ? dayjs(reportData.depApproverUpdateDate3).format('YYYY/MM/DD')
          : '',
        DEP_APPROVER_ID_4: depApproverIdArray[3] || '',
        DEP_APPROVER_NM_4: reportData.depApproverNm4 || '',
        DEP_APPROVER_POSITION_4: reportData.depApproverPosition4 || '',
        DEP_APPROVER_DEP_NM_4: reportData.depApproverDepNm4 || '',
        DEP_SIGN_PATH_4: depSignBase644 || null,
        DEP_APPROVER_UPDATE_DATE_4: reportData.depApproverUpdateDate4
          ? dayjs(reportData.depApproverUpdateDate4).format('YYYY/MM/DD')
          : '',
        SAFETY_APPROVAL_STATUS: reportData.safetyApprovalStatus || '',
        SAFETY_APPROVER_ID: reportData.safetyApproverId || '',
        SAFETY_APPROVER_NM: reportData.safetyApproverNm || '',
        SAFETY_APPROVER_POSITION: reportData.safetyApproverPosition || '',
        SAFETY_APPROVER_DEP_NM: reportData.safetyApproverDepNm || '',
        SAFETY_SIGNATURE_PATH: smSignBase64,
        SAFETY_APPROVER_UPDATE_DATE: reportData.safetyApproverUpdateDate
          ? dayjs(reportData.safetyApproverUpdateDate).format('YYYY/MM/DD')
          : '',
        RETURN_STATUS: reportData.returnStatus || '',
        RETURN_REASON: reportData.returnReason || '',
        RETURN_USER_ID: reportData.returnUserId || '',
        PM_CD: reportData.pmCd,
        CUST_CD: reportData.custCd,
        DEP_CD: reportData.depCd,
        USER_ID: reportData.userId,
      };

      const printData = {
        FileName: 'PER_CUSTOM',
        HeaderData: JSON.stringify(headerData),
        TableDataMain: tableDataMain,
        TableData1: JSON.stringify(riskTableDataHorizontal),
        TableData2: JSON.stringify(equipmentTableDataHorizontal),
        TableData3: JSON.stringify(preparationTableData),
        TableData4: JSON.stringify([]),
        TableData5: JSON.stringify([]),
        TableData6: JSON.stringify([]),
      };


      const pdfRes = await Commons.Axios(
        'report',
        Global.base.useUrl + Global.urls.Reports.reports,
        printData
      );

      if (
        !pdfRes?.data ||
        pdfRes?.headers['content-type'] !== 'application/pdf'
      ) {
        throw new Error('PDF 응답이 비어 있거나 PDF가 아닙니다.');
      }

      await RenderPdfToImages(await pdfRes.data.arrayBuffer());
      setLoading(false);
    },
  });
  //#endregion

  //#region 나머지 함수
  const ConvertImageToBase64 = async (url) => {
    const response = await fetch(url);
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  const RenderPdfToImages = async (pdfBlob) => {
    const pdf = await pdfjsLib.getDocument({ data: pdfBlob }).promise;
    const images = [];

    for (let i = 1; i <= pdf.numPages; i++) {
      const page = await pdf.getPage(i);
      const viewport = page.getViewport({ scale: 1.5 });
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');

      canvas.height = viewport.height;
      canvas.width = viewport.width;

      await page.render({ canvasContext: context, viewport }).promise;
      images.push(canvas.toDataURL('image/png'));
    }

    setPdfImages(images);
  };

  const GoToPrevPage = () => {
    dispatch(CommonActions.setActiveStep(activeStep - 1));
  };
  //#endregion

  return (
    <M_TBG_CUSTOM_05
      userInfo={userInfo}
      activeStep={activeStep}
      pdfImages={pdfImages}
      loading={loading}
      setActiveStep={(step) => dispatch(CommonActions.setActiveStep(step))}
      ActiveButton={props.ActiveButton}
      goToPrevPage={GoToPrevPage}
    />
  );
}

export default M_TBG_CUSTOM_05F;
